/**
 * Fire a custom Umami analytics event. Safe no-op when the Umami script
 * has not loaded (dev mode, blocked, or not yet initialized).
 *
 * @param {string} eventName - Name of the event to track.
 * @param {Record<string, unknown>} [eventData] - Optional event payload.
 */
export const trackEvent = (eventName: string, eventData?: Record<string, unknown>): void => {
    if (typeof window === 'undefined') return;
    window.umami?.track(eventName, eventData);
};
